
import { defineComponent } from "vue";

export default defineComponent({
  props: {
    deg: {
      type: Number,
      default: 0,
    },
    offset: {
      type: Number,
      default: 0,
    },
    width: {
      type: Number,
      default: 0,
    },
    height: {
      type: Number,
      default: 0,
    },
    src: String,
    to: String,
    click: Function,
  },
  computed: {
    style(): {
      [key: string]: string;
    } {
      return {
        transform: `rotateY(${this.deg}deg) translateZ(-${this.offset}px)`,
        width: `${this.width}px`,
        height: `${this.height}px`,
      };
    },
    styleInner(): {
      [key: string]: string;
    } {
      return {
        backgroundImage: `url('${this.src}')`,
        backgroundSize: `cover`,
      };
    },
  },
});
